import React from 'react'
import { Props_SnippetHeading } from './Heading.props'

const SnippetHeading = (props: Props_SnippetHeading) => {
    const classHeadingAlignment = `snippet-heading--alignment-${props.snippet?.alignment?.value}`

    return (
        <section className={`snippet-heading ${classHeadingAlignment}`}>
            { props.snippet?.level?.value && React.createElement(props.snippet.level.value, { className: 'snippet-heading__heading' }, props.snippet?.heading?.value) }
        </section>
    )
}

export default SnippetHeading